import styles from "./howitworks.module.css";
import { howItWorksImage } from "@/assets/images";
import {
  HowItWorksBuildingGraphics,
  HowItWorksConnectingLine,
  HowItWorksDecorativeIcon,
} from "@/assets/svg";

/**
 * HowItWorks Component
 * Four-step process visualization matching the design
 */
export const HowItWorks = () => {
  return (
    <section id="how-it-works" className={styles.howItWorksSection}>
      <div className={styles.howItWorksContent}>
        <h2 className={styles.howItWorksTitle}>
          How It <span className={styles.worksHighlight}>Works</span>
        </h2>
        <p className={styles.howItWorksSubtitle}>Save on property taxes in just four easy steps.</p>

        <div className={styles.stepsContainer}>
          {/* Bottom-left background image */}
          <div
            className={styles.bottomLeftBg}
            style={{ backgroundImage: `url(${howItWorksImage})` }}
            aria-hidden="true"
          />

          {/* Decorative elements */}
          <div className={styles.decorativeIcon1}>
            <HowItWorksDecorativeIcon />
          </div>
          <div className={styles.decorativeIcon2}>
            <HowItWorksDecorativeIcon />
          </div>

          {/* Background building graphics */}
          <div className={styles.backgroundGraphics}>
            <HowItWorksBuildingGraphics className={styles.buildingGraphics} />
          </div>

          {/* Connecting line */}
          <HowItWorksConnectingLine className={styles.connectingLine} />

          {/* Step 1: Add Property */}
          <div className={`${styles.step} ${styles.step1}`}>
            <div className={styles.stepNumberBg} aria-hidden="true">
              <span className={styles.stepNumberText}>1</span>
            </div>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>Add Property</h3>
              <p className={styles.stepDescription}>
                Enter property using ZIP or address to locate your home details.
              </p>
            </div>
          </div>

          {/* Step 2: Review Tax Details */}
          <div className={`${styles.step} ${styles.step2}`}>
            <div className={styles.stepNumberBg} aria-hidden="true">
              <span className={styles.stepNumberText}>2</span>
            </div>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>Review Tax Details</h3>
              <p className={styles.stepDescription}>
                See county expectations to find potential savings.
              </p>
            </div>
          </div>

          {/* Step 3: File Protest */}
          <div className={`${styles.step} ${styles.step3}`}>
            <div className={styles.stepNumberBg} aria-hidden="true">
              <span className={styles.stepNumberText}>3</span>
            </div>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>File Protest</h3>
              <p className={styles.stepDescription}>
                Prepare and submit your protest with our streamlined tools.
              </p>
            </div>
          </div>

          {/* Step 4: Track Status */}
          <div className={`${styles.step} ${styles.step4}`}>
            <div className={styles.stepNumberBg} aria-hidden="true">
              <span className={styles.stepNumberText}>4</span>
            </div>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>Track Status</h3>
              <p className={styles.stepDescription}>
                Monitor updates and progress throughout the protest season.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
